<template>
    <section
        :id="titleArr.id"
        :class="[titleArr.type=='level'?'m-title3':'m-title2',titleArr.id?'nav_choose':'']"
        class
    >
        <span>
            {{titleArr.name}}
            <i v-if="titleArr.levelTitle">{{titleArr.levelTitle}}</i>
        </span>
        <p class="u-title-line"></p>
    </section>
</template>

<script>
export default {
    name: "Title",
    props: {
        titleArr: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            msg: "title"
        };
    }
};
</script>  


